import { createFileRoute } from '@tanstack/react-router'
import { TransactionSection } from '../components/Transactions/TransactionSection'
import { TransactionToolbar } from '../components/Transactions/TransactionToolbar'
import { withErrorBoundary } from '../components/hoc/withErrorBoundary'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { useTranslation } from 'react-i18next'

const Transactions = () => {
  const { t } = useTranslation()
  return (
    <Stack
      sx={{
        gap: 2,
      }}
    >
      <Typography variant='h2'>{t('transactions.title')}</Typography>
      <TransactionSection
        listLimit={null}
        showViewAllButton={false}
        paperLayout={false}
        toolbar={<TransactionToolbar />}
      />
    </Stack>
  )
}

export const Route = createFileRoute('/transactions')({
  component: withErrorBoundary(Transactions),
})
